import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Moon: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_16825_185184)">
      <path
        d="M8.0004 1.32812C6.79354 1.32835 5.60938 1.65617 4.57422 2.27663C3.53907 2.89709 2.69176 3.78692 2.12267 4.85118C1.55358 5.91544 1.28407 7.11423 1.34288 8.31966C1.40169 9.52508 1.78662 10.6919 2.4566 11.6958C3.12658 12.6996 4.05649 13.5027 5.14712 14.0194C6.23776 14.5362 7.44821 14.7472 8.64937 14.6299C9.85052 14.5127 10.9973 14.0715 11.9674 13.3536C12.9375 12.6357 13.6945 11.6679 14.1577 10.5535C14.3851 10.0068 13.8404 9.45746 13.2924 9.68013C12.3532 10.0606 11.3103 10.0998 10.3452 9.79108C9.38001 9.48232 8.55358 8.84508 8.00957 7.99014C7.46555 7.1352 7.23836 6.11664 7.3675 5.11156C7.49664 4.10648 7.97393 3.17844 8.7164 2.48879L8.76774 2.43546C9.13507 2.01546 8.84307 1.33346 8.2624 1.33346H8.08507L8.03974 1.32946L7.99974 1.32812H8.0004Z"
        fill="#3B0297"
      />
    </g>
    <defs>
      <clipPath id="clip0_16825_185184">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Moon;
